import React, { useContext } from 'react';
import { Col, Row, Table } from 'reactstrap';

import { Datepicker, Input, Autocomplete } from '@/components/form';
import ResourceList from '@/components/resources/list';
import View from '@/components/view';
import Context from '@/services/context';
import { t } from '@/services/translator';

export default () => {
  const { locale } = useContext(Context);

  return (
    <View>
      <ResourceList
        resource="DashboardLayout"
        deleteMultiple
        filters={() => (
          <Row>
            <Col lg={4}>
              <Input name="name" />
            </Col>
            <Col lg={4}>
              <Autocomplete name="type" autoload resource="DashboardLayoutType" tag="name" display="name" clearable />
            </Col>
            <Col lg={4}>
              <Autocomplete name="report" resource="Report" tag="name" display="name" clearable />
            </Col>
            <Col lg={4}>
              <Input name="alias" />
            </Col>
            <Col lg={3}>
              <Datepicker name="['createdAt[after]']" label="diagnostic.start_date.after" />
            </Col>
            <Col lg={3}>
              <Datepicker name="['createdAt[before]']" label="diagnostic.start_date.before" />
            </Col>
          </Row>
        )}
        body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
          <Table responsive hover>
            <thead className="thead-light">
              <tr>
                {renderColumn(renderSelect('*'), false)}
                {renderColumn('id')}
                {renderColumn('name')}
                {renderColumn('type')}
                {renderColumn()}
              </tr>
            </thead>
            <tbody>
              {collection.map((item) => (
                <tr key={item.id}>
                  <td>{renderSelect(item.id)}</td>
                  <td>{item.id}</td>
                  <td>{item.name[locale]}</td>
                  <td>{item.type ? t(item.type.name) : null}</td>
                  <td>{renderItemActions(item)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      />
    </View>
  );
};
